import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import TuneIcon from '@mui/icons-material/Tune';




const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
  },
}));

export default function SortingMenu(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    props.setGridFilter(true);
  };

  return (
    <div>
      <Button
        id="demo-customized-button"
        aria-controls={open ? 'demo-customized-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        variant="contained"
        disableElevation
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
      >
        {props.name}
      </Button>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{'aria-labelledby': 'demo-customized-button',}}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem  style={{color : props.sortBy == 1 ? 'green' : '' , fontWeight :props.sortBy == 1 ?  '600' : ''}} 
         onClick={()=>  {props.sortByName(1)}} disableRipple>
          <CalendarMonthIcon />
          Date
        </MenuItem>
        <MenuItem style={{color : props.sortBy == 2 ? 'green' : '' , fontWeight :props.sortBy == 2   ?  '600' : ''}}  
        onClick={()=>  {props.sortByName(2)}} disableRipple>
          <TuneIcon />
          Alphabetical Order
        </MenuItem>
        <Divider sx={{ my: 0.5 }} />
        <MenuItem style={{color : props.orderBy == 1 ? 'green' : '' , fontWeight :props.orderBy == 1 ?  '600' : ''}} onClick={()=>  {props.sortByAcsending(1)}} disableRipple>
          {/* <TuneIcon /> */}
          {/* { orderBy == 'acs' ?  } */}
          Ascending
        </MenuItem>
        <MenuItem  style={{color : props.orderBy == 2 ? 'green' : '' , fontWeight :props.orderBy == 2 ?  '600' : ''}}
         onClick={()=>  {props.sortByAcsending(2)}} disableRipple>
          {/* <TuneIcon /> */}
          Decending
        </MenuItem>
      </StyledMenu>
    </div>
  );
}